import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { MessageStore } from 'src/Stores/Messages/Messages';

interface IMessageObject {
    key: number;
    text: string;
    type: string;
    timeout?: number;
}
@inject('stores')
@observer
class Message extends React.Component {
    public props: any;
    public messages: any[];
    public disposer: any;
    private MessageStore: MessageStore;


    public state = {
        empty: true,
        messages: []
    };

    constructor(props: any) {
        super(props);
        this.MessageStore = this.props.stores.MessageStore;
        this.createMessage = this.createMessage.bind(this);
    }

    public componentDidMount() {
        this.setState({
            messages: this.MessageStore.messages || []
        });

        this.disposer = observe(this.MessageStore, 'messages', (change: any) => {
            this.setState({
                messages: change.newValue.slice()
            });
        });
    }

    public componentWillUnmount() {
        this.disposer();
    }

    public removeMessage(message: any) {
        this.MessageStore.removeMessage(message);
    }

    public removeAllMessages() {
        this.MessageStore.removeAllMessages();
    }

    public onDismissAlert = (message: IMessageObject) => (event: any) => {
        window.setTimeout(
            () => {
                this.MessageStore.removeMessage(message);
            },
            200
        );
    }

    public createMessage(message: IMessageObject, index: any) {
        if ( (message.type !== 'danger' && message.type !== 'warning') || message.timeout ) {
            window.setTimeout(
                () => {
                    this.MessageStore.removeMessage(message);
                },
                message.timeout ? message.timeout : 1000
            );
        }

        return (
            <UncontrolledAlert
                key={message.key}
                color={message.type || 'primary'}
                toggle={this.onDismissAlert(message)}>
                <div dangerouslySetInnerHTML={{__html: message.text}} />
            </UncontrolledAlert>
        );
    }

    public render() {
        return(
            <div className="snackbar-wrapper">
                {this.state.messages.map((message, index) =>
                    this.createMessage(message, index)
                )}
            </div>
        );
    }

}

export default Message;



// WEBPACK FOOTER //
// ./src/Components/Messaging/Message.tsx